import { request } from '@@/plugin-request';

export async function signin(data) {
  return request('/api/auth/signin', {
    method: 'POST',
    data,
  });
}

export async function smsTwoFactor(data) {
  return request('/api/auth/twoFactor', {
    method: 'POST',
    data,
  });
}

export async function twoFactorVerify(data) {
  return request('/api/auth/twoFactorVerify', {
    method: 'POST',
    data,
  });
}

export async function refresh() {
  return request('/api/auth/refresh', {
    method: 'POST',
  });
}

export async function signout() {
  return request('/api/auth/signout', {
    method: 'POST',
  });
}

export async function listServiceAccounts() {
  return request('/api/service-accounts', {
    method: 'GET',
  });
}

export async function createServiceAccount(data) {
  return request('/api/service-accounts', {
    method: 'POST',
    data,
  });
}

export async function deleteServiceAccount(id) {
  return request(`/api/service-accounts/${id}`, {
    method: 'DELETE',
  });
}

export async function regenerateServiceAccountKey(id, data) {
  return request(`/api/service-accounts/${id}/regenerate-key`, {
    method: 'POST',
    data,
  });
}

export async function listAllApiKeys(type, userId) {
  const params = {};
  if (type) params.type = type;
  if (userId) params.userId = userId;
  return request('/api/api-keys', {
    method: 'GET',
    params,
  });
}

export async function revokeApiKey(id) {
  return request(`/api/api-keys/${id}`, {
    method: 'DELETE',
  });
}

export async function listDevices() {
  return request('/api/auth/devices', {
    method: 'GET',
  });
}

export async function revokeDevice(id) {
  return request(`/api/auth/devices/${id}`, {
    method: 'DELETE',
  });
}

export async function revokeAllDevices() {
  return request('/api/auth/devices', {
    method: 'DELETE',
  });
}

//检查是否关联
export async function checkConnect(data) {
  return request('/api/wechat/connected', {
    method: 'POST',
    data,
  });
}

//更改忘记密码
export async function changeForgetPassword(data) {
  return request('/api/auth/changeForgetPassword', {
    method: 'PUT',
    data,
  });
}